interface Props {
  color?: string;
  width?: number;
  height?: number;
}

const LinkedIn = ({ color = "#0076B2", width = 16, height = 16 }: Props) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8196 6.05898e-05H1.18032C0.870854 -0.00308887 0.572778 0.116656 0.351498 0.333019C0.130217 0.549383 0.00380473 0.844693 0 1.15415V14.8485C0.0044928 15.1575 0.131207 15.4521 0.352413 15.6679C0.573619 15.8837 0.871302 16.0031 1.18032 15.9999H14.8196C15.129 16.0024 15.4269 15.8822 15.6481 15.6657C15.8693 15.4492 15.9957 15.154 15.9999 14.8445V1.15022C15.9944 0.841666 15.8673 0.547764 15.6463 0.332393C15.4252 0.117023 15.1281 -0.0024078 14.8196 6.05898e-05Z"
        fill={color}
      />
      <path
        d="M2.36854 5.99856H4.7436V13.6405H2.36854V5.99856ZM3.55673 2.19531C3.82914 2.19531 4.09542 2.27611 4.3219 2.42748C4.54839 2.57885 4.72488 2.79399 4.82907 3.04568C4.93326 3.29738 4.96045 3.57433 4.90721 3.84148C4.85397 4.10864 4.72269 4.354 4.52998 4.54653C4.33726 4.73906 4.09177 4.87011 3.82457 4.92309C3.55736 4.97608 3.28045 4.94862 3.02885 4.84419C2.77725 4.73977 2.56228 4.56306 2.41112 4.33644C2.25997 4.10981 2.17943 3.84345 2.17969 3.57104C2.18004 3.20605 2.32527 2.85614 2.58348 2.59817C2.84168 2.34021 3.19174 2.19531 3.55673 2.19531ZM6.23343 5.99856H8.51013V7.04773H8.54161C8.85898 6.44708 9.63275 5.81365 10.7881 5.81365C13.1934 5.8084 13.6393 7.39134 13.6393 9.44378V13.6405H11.2642V9.92247C11.2642 9.03723 11.2485 7.89756 10.0301 7.89756C8.81177 7.89756 8.60456 8.8628 8.60456 9.86476V13.6405H6.23343V5.99856Z"
        fill="white"
      />
    </svg>
  );
};

export default LinkedIn;
